import ChatComponent, { DocumentInfo } from "./ChatComponent";

interface StandaloneChatDrawerProps {
  onClose?: () => void;
  isChatNotificationOpen: boolean;
  setIsChatNotificationOpen: (value: boolean) => void;
  documentId?: number;
  userId: number;
  documentInfo?: DocumentInfo;
  customChatRoomId: string | null;
  type: StandaloneChatDrawerType;
}

export enum StandaloneChatDrawerType {
  DOCUMENT = "document",
  USER = "user",
}

const StandaloneChatDrawer = ({
  onClose,
  isChatNotificationOpen,
  setIsChatNotificationOpen,
  documentId,
  userId,
  documentInfo,
  customChatRoomId,
  type = StandaloneChatDrawerType.USER,
}: StandaloneChatDrawerProps) => {
  return (
    <ChatComponent
      onClose={onClose}
      isChatNotificationOpen={isChatNotificationOpen}
      setIsChatNotificationOpen={setIsChatNotificationOpen}
      documentId={documentId}
      userId={userId}
      documentInfo={documentInfo}
      customChatRoomId={customChatRoomId}
      type={type}
    />
  );
};

export default StandaloneChatDrawer;
